"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _luxon = require("luxon");

var _ = require(".");

var ParasiteSpecies =
/** @class */
function () {
  function ParasiteSpecies() {
    this.id = null;
    this.name = null;
    this.technicalName = null;
    this.commonName = null;
    this.isActive = null;
    this.resultsKey = null;
    this.resultsColor = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.testTypes = null;
    this.testTypeParasiteSpecies = null;
  }

  ParasiteSpecies.thaw = function (parasiteSpeciesObj) {
    var _a, _b;

    if (parasiteSpeciesObj == null) return null;
    var parasiteSpecies = new ParasiteSpecies();

    if (parasiteSpeciesObj.id != null) {
      parasiteSpecies.setId(parasiteSpeciesObj.id);
    }

    if (parasiteSpeciesObj.name != null) {
      parasiteSpecies.setName(parasiteSpeciesObj.name);
    }

    if (parasiteSpeciesObj.technicalName != null) {
      parasiteSpecies.setTechnicalName(parasiteSpeciesObj.technicalName);
    }

    if (parasiteSpeciesObj.commonName != null) {
      parasiteSpecies.setCommonName(parasiteSpeciesObj.commonName);
    }

    if (parasiteSpeciesObj.isActive != null) {
      parasiteSpecies.setIsActive(parasiteSpeciesObj.isActive == null ? null : parasiteSpeciesObj.isActive ? true : false);
    }

    if (parasiteSpeciesObj.resultsKey != null) {
      parasiteSpecies.setResultsKey(parasiteSpeciesObj.resultsKey);
    }

    if (parasiteSpeciesObj.resultsColor != null) {
      parasiteSpecies.setResultsColor(parasiteSpeciesObj.resultsColor);
    }

    if (parasiteSpeciesObj.createdAt != null) {
      parasiteSpecies.setCreatedAt((_a = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(parasiteSpeciesObj.createdAt)) !== null && _a !== void 0 ? _a : null);
    }

    if (parasiteSpeciesObj.updatedAt != null) {
      parasiteSpecies.setUpdatedAt((_b = _luxon.DateTime === null || _luxon.DateTime === void 0 ? void 0 : _luxon.DateTime.fromISO(parasiteSpeciesObj.updatedAt)) !== null && _b !== void 0 ? _b : null);
    }

    if (parasiteSpeciesObj.testTypes != null) {
      parasiteSpecies.setTestTypes(_.TestType.thawList(parasiteSpeciesObj.testTypes));
    }

    if (parasiteSpeciesObj.testTypeParasiteSpecies != null) {
      parasiteSpecies.setTestTypeParasiteSpecies(_.TestTypeParasiteSpecies.thaw(parasiteSpeciesObj.testTypeParasiteSpecies));
    }

    return parasiteSpecies;
  };

  ParasiteSpecies.thawList = function (parasiteSpeciesObjList) {
    if (parasiteSpeciesObjList == null) {
      return [];
    }

    var parasiteSpecieses = [];

    for (var i = 0; i < parasiteSpeciesObjList.length; i++) {
      parasiteSpecieses.push(ParasiteSpecies.thaw(parasiteSpeciesObjList[i]));
    }

    return parasiteSpecieses;
  };

  ParasiteSpecies.freeze = function (parasiteSpecies) {
    var _a, _b, _c, _d;

    if (parasiteSpecies == null) {
      return null;
    }

    var parasiteSpeciesObj = {};

    if (parasiteSpecies.getId() != null) {
      parasiteSpeciesObj.id = parasiteSpecies.getId();
    }

    if (parasiteSpecies.getName() != null) {
      parasiteSpeciesObj.name = parasiteSpecies.getName();
    }

    if (parasiteSpecies.getTechnicalName() != null) {
      parasiteSpeciesObj.technicalName = parasiteSpecies.getTechnicalName();
    }

    if (parasiteSpecies.getCommonName() != null) {
      parasiteSpeciesObj.commonName = parasiteSpecies.getCommonName();
    }

    if (parasiteSpecies.getIsActive() != null) {
      parasiteSpeciesObj.isActive = parasiteSpecies.getIsActive() == null ? null : parasiteSpecies.getIsActive() ? 1 : 0;
    }

    if (parasiteSpecies.getResultsKey() != null) {
      parasiteSpeciesObj.resultsKey = parasiteSpecies.getResultsKey();
    }

    if (parasiteSpecies.getResultsColor() != null) {
      parasiteSpeciesObj.resultsColor = parasiteSpecies.getResultsColor();
    }

    if (parasiteSpecies.getCreatedAt() != null) {
      parasiteSpeciesObj.createdAt = (_b = (_a = parasiteSpecies.getCreatedAt()) === null || _a === void 0 ? void 0 : _a.toISO()) !== null && _b !== void 0 ? _b : null;
    }

    if (parasiteSpecies.getUpdatedAt() != null) {
      parasiteSpeciesObj.updatedAt = (_d = (_c = parasiteSpecies.getUpdatedAt()) === null || _c === void 0 ? void 0 : _c.toISO()) !== null && _d !== void 0 ? _d : null;
    }

    if (parasiteSpecies.getTestTypes() != null) {
      parasiteSpeciesObj.testTypes = _.TestType.freezeList(parasiteSpecies.getTestTypes());
    }

    if (parasiteSpecies.getTestTypeParasiteSpecies() != null) {
      parasiteSpeciesObj.testTypeParasiteSpecies = _.TestTypeParasiteSpecies.freeze(parasiteSpecies.getTestTypeParasiteSpecies());
    }

    return parasiteSpeciesObj;
  };

  ParasiteSpecies.freezeList = function (parasiteSpecieses) {
    if (parasiteSpecieses == null) {
      return [];
    }

    var parasiteSpeciesObjList = [];

    for (var i = 0; i < parasiteSpecieses.length; i++) {
      parasiteSpeciesObjList.push(ParasiteSpecies.freeze(parasiteSpecieses[i]));
    }

    return parasiteSpeciesObjList;
  };
  /* -------------------------
     -------------------------
     -------- SETTERS --------
     -------------------------
     ------------------------- */


  ParasiteSpecies.prototype.setId = function (id) {
    this.id = id;
  };

  ParasiteSpecies.prototype.setName = function (name) {
    this.name = name;
  };

  ParasiteSpecies.prototype.setTechnicalName = function (technicalName) {
    this.technicalName = technicalName;
  };

  ParasiteSpecies.prototype.setCommonName = function (commonName) {
    this.commonName = commonName;
  };

  ParasiteSpecies.prototype.setIsActive = function (isActive) {
    this.isActive = isActive;
  };

  ParasiteSpecies.prototype.setResultsKey = function (resultsKey) {
    this.resultsKey = resultsKey;
  };

  ParasiteSpecies.prototype.setResultsColor = function (resultsColor) {
    this.resultsColor = resultsColor;
  };

  ParasiteSpecies.prototype.setCreatedAt = function (createdAt) {
    this.createdAt = createdAt;
  };

  ParasiteSpecies.prototype.setUpdatedAt = function (updatedAt) {
    this.updatedAt = updatedAt;
  };

  ParasiteSpecies.prototype.setTestTypes = function (testTypes) {
    this.testTypes = testTypes;
  };

  ParasiteSpecies.prototype.setTestTypeParasiteSpecies = function (testTypeParasiteSpecies) {
    this.testTypeParasiteSpecies = testTypeParasiteSpecies;
  };
  /* -------------------------
     -------------------------
     -------- GETTERS --------
     -------------------------
     ------------------------- */


  ParasiteSpecies.prototype.getId = function () {
    return this.id;
  };

  ParasiteSpecies.prototype.getName = function () {
    if (this.name == null && this.commonName != null && this.technicalName != null) {
      this.name = "".concat(this.commonName, " (").concat(this.technicalName, ")");
    }

    return this.name;
  };

  ParasiteSpecies.prototype.getTechnicalName = function () {
    return this.technicalName;
  };

  ParasiteSpecies.prototype.getCommonName = function () {
    return this.commonName;
  };

  ParasiteSpecies.prototype.getIsActive = function () {
    return this.isActive;
  };

  ParasiteSpecies.prototype.getResultsKey = function () {
    return this.resultsKey;
  };

  ParasiteSpecies.prototype.getResultsColor = function () {
    return this.resultsColor;
  };

  ParasiteSpecies.prototype.getCreatedAt = function () {
    return this.createdAt;
  };

  ParasiteSpecies.prototype.getUpdatedAt = function () {
    return this.updatedAt;
  };

  ParasiteSpecies.prototype.getTestTypes = function () {
    return this.testTypes;
  };

  ParasiteSpecies.prototype.getTestTypeParasiteSpecies = function () {
    return this.testTypeParasiteSpecies;
  };

  return ParasiteSpecies;
}();

var _default = ParasiteSpecies;
exports.default = _default;